


























import { AdgroupFormData } from '@tt4b/ttam-enums';
import { computed, defineComponent, toRefs, ref } from '@vue/composition-api';
import { PropType } from 'vue';
import TreeNodeHoverEstimate from '@/components/common/tree-node-hover-estimate/index.vue';

const name = 'ttam-behavior-video-category';
export default defineComponent({
  components: {
    TreeNodeHoverEstimate,
  },
  model: {
    prop: 'selectedCategories',
    event: 'change',
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
    },
    videoBehaviorList: {
      type: Array as PropType<Array<number>>,
      default: () => [],
    },
    selectedCategories: {
      type: Array as PropType<Array<number>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { selectedCategories, adgroupData } = toRefs(props);
    const adgroupId = computed(() => adgroupData.value?.adId || '');

    const _selectedCategories = computed({
      get: () => selectedCategories.value,
      set: val => {
        emit('change', val);
      },
    });

    /** 处理节点 hover 内容 */
    const hoverContentNode = ref();
    function onMouseEnterNode(data) {
      const hoverNodeData = data?.data ?? {};
      hoverContentNode?.value?.showHoverEstimate?.(hoverNodeData);
    }

    return {
      name,
      adgroupId,
      hoverContentNode,
      _selectedCategories,
      onMouseEnterNode,
    };
  },
});
